import Axios from 'axios';

import { TABLET_API_ORIGIN } from '@/global/env';
import { RestClientInterface } from '@/lib/restClient';
import {
  PresignedRequest,
  PresignedResponse,
} from '@/services/CamelOrder/hooks/presignedUrl/usePresigned';

interface Interface {
  presigned: (params: PresignedRequest) => Promise<PresignedResponse>;
}

export class CamelOrderService implements Interface {
  constructor(private readonly restClient: RestClientInterface) {}

  public async presigned(params: PresignedRequest): Promise<PresignedResponse> {
    return await this.restClient.get(
      `${TABLET_API_ORIGIN}/dashboard-api/camel-order/presigned?file_path=${params.filePath}&content_type=${params.contentType}` as const
    );
  }

  public async createS3Image(presignedUrl: string, file: File): Promise<void> {
    await Axios.put(presignedUrl, file, {
      headers: { 'Content-Type': file.type },
    });
  }
}
